import type { ConfirmationManagerState } from './ConfirmationManager.types';

export const closeConfirmationCallback = (prevState: ConfirmationManagerState[]) =>
    prevState.map((confirmation) => ({
        ...confirmation,
        open: false,
    }));
